import { render, staticRenderFns } from "./DefaultFromAddress.vue?vue&type=template&id=1a3c90a7&scoped=true"
import script from "./DefaultFromAddress.vue?vue&type=script&lang=js"
export * from "./DefaultFromAddress.vue?vue&type=script&lang=js"
import style0 from "./DefaultFromAddress.vue?vue&type=style&index=0&id=1a3c90a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3c90a7",
  null
  
)

/* custom blocks */
import block0 from "./DefaultFromAddress.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports